const getBlogPath = (slug: string) => {
  return `${slug}`
}
export default getBlogPath
